import React from 'react';
import EditFAQsComponent from '../../components/admin/EditFAQsComponent';

const EditFAQs = () => {

    return <><EditFAQsComponent /></>;
    };
  
  export default EditFAQs;